import { gql } from '@apollo/client';

const Fragments = {
  comment: gql`
    fragment comment on Comment {
      commentId
      parentCommentId
      commentText
      parentCommentText
      internal
      deleted
      edited
      canReply
      canEdit
      canDelete
      date
      userId
      userName
      userEmail
      userPartnerId
      isCurrentUser
      documentStateId
      documentStateName
      recipients
    }
  `
};

export default Fragments;
